import { render, staticRenderFns } from "./table-card.vue?vue&type=template&id=49aa71bd&scoped=true"
import script from "./table-card.vue?vue&type=script&lang=js"
export * from "./table-card.vue?vue&type=script&lang=js"
import style0 from "./table-card.vue?vue&type=style&index=0&id=49aa71bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49aa71bd",
  null
  
)

export default component.exports